import React from 'react';
import styles from './AddReport.module.scss';

export const PRJPlate = () => <div className={styles.project_plate}>PRJ</div>;
